module.exports = __webpack_public_path__ + "img/accrued.5e679d8a.svg";